import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';

Vue.component('vue-recaptcha', VueRecaptcha);
